module.exports = __webpack_public_path__ + "static/media/mapa-pomoci-switched-colors.472cf21e.svg";